module.exports = __webpack_public_path__ + "static/media/faq.12b9333c.svg";